import lodash from 'lodash';
import moment from 'moment';

import { reportTypes, DATE_FORMAT } from './constants';
import { nodeWithArgs } from 'common/util/queryHelper';
import styles from '../containers/ReportContent.scss';

export const unfiledDocumentReportColumns = {
    binderName: { key: 'binderName', label: 'Binder Name', filter: 'Filter name' },
    documentName: { key: 'documentName', label: 'Document Name', filter: 'Filter name' },
    uploadedUserName: { key: 'uploadedUserName', label: 'Uploaded User Name', filter: 'Filter user name' },
    uploadedUserEmail: { key: 'uploadedUserEmail', label: 'Uploaded User Email', filter: 'Filter email' },
    uploadedDate: { key: 'uploadedDate', label: 'Uploaded Date', filter: 'Filter date' },
    daysSinceUploaded: { key: 'daysSinceUploaded', label: 'Days since Uploaded', filter: 'Filter days' },
};

const unfiledDocumentReportColumnsValues = lodash.values(unfiledDocumentReportColumns);

export const unfiledDocumentReportDefaultColumns = lodash.map(unfiledDocumentReportColumnsValues, 'key');

export const unfiledDocumentReportColumnsList = lodash.orderBy(unfiledDocumentReportColumnsValues, ['label'], ['asc']);

export const getUnfiledDocumentsReportNode = (institutionId) => {
    return nodeWithArgs('getUnfiledDocumentsReportRawData', {
        institutionId
    }, [
        'binderName',
        'documentName',
        'uploadedUserName',
        'uploadedUserEmail',
        'uploadedDate',
        'daysSinceUploaded',
    ]);
};

export function renderUnfiledDocumentsColumns(documents, customizeColumns) {
    if (lodash.isEmpty(documents)) {
        return [];
    }
    const formattedColumns = formatMaterialTableUnfiledDocumentsColumns(customizeColumns);

    return [...formattedColumns];
}

const formatMaterialTableUnfiledDocumentsColumns = customizeColumns => {
    return [
        {
            title: unfiledDocumentReportColumns.binderName.label,
            field: unfiledDocumentReportColumns.binderName.key,
            filterPlaceholder: unfiledDocumentReportColumns.binderName.filter,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.binderName.key),
            render: rowData => {
                return !lodash.isEmpty(rowData[unfiledDocumentReportColumns.binderName.key]) ? (
                    rowData[unfiledDocumentReportColumns.binderName.key]
                ) : (
                    <p className={styles.emptyLabel}>No B.N Provided</p>
                );
            },
            cellStyle: {
                minWidth: '250px',
            },
        },
        {
            title: unfiledDocumentReportColumns.documentName.label,
            field: unfiledDocumentReportColumns.documentName.key,
            filterPlaceholder: unfiledDocumentReportColumns.documentName.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.U.E Provided</p>,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.documentName.key),
        },
        {
            title: unfiledDocumentReportColumns.uploadedUserName.label,
            field: unfiledDocumentReportColumns.uploadedUserName.key,
            filterPlaceholder: unfiledDocumentReportColumns.uploadedUserName.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.U.N Provided</p>,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.uploadedUserName.key),
        },
        {
            title: unfiledDocumentReportColumns.uploadedUserEmail.label,
            field: unfiledDocumentReportColumns.uploadedUserEmail.key,
            filterPlaceholder: unfiledDocumentReportColumns.uploadedUserEmail.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.U.E Provided</p>,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.uploadedUserEmail.key),
        },
        {
            title: unfiledDocumentReportColumns.uploadedDate.label,
            field: unfiledDocumentReportColumns.uploadedDate.key,
            filterPlaceholder: unfiledDocumentReportColumns.uploadedDate.filter,
            emptyValue: <p className={styles.emptyLabel}>No U.D Provided</p>,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.uploadedDate.key),
            render: rowData => {
                return moment(rowData[unfiledDocumentReportColumns.uploadedDate.key]).format(DATE_FORMAT);
            },
        },
        {
            title: unfiledDocumentReportColumns.daysSinceUploaded.label,
            field: unfiledDocumentReportColumns.daysSinceUploaded.key,
            filterPlaceholder: unfiledDocumentReportColumns.daysSinceUploaded.filter,
            emptyValue: <p className={styles.emptyLabel}>No D.s.U Provided</p>,
            hidden: !customizeColumns.includes(unfiledDocumentReportColumns.daysSinceUploaded.key),
            customSort: (a, b) => Number(a.daysSinceUploaded) - Number(b.daysSinceUploaded),
        },
    ];
};

export const reportUnfiledDocumentOptionData = {
    name: reportTypes.unfiledDocument,
    displayName: 'Unfiled Document Reports',
    reportType: reportTypes.unfiledDocument,
    parameters: [
        {
            id: 'institutionId',
            choice: 'institutionId',
            choiceLabel: 'Get a report on all binders for this Institution',
            isChoiceRequired: true,
            isChoiceHidden: true,
            label: 'Institution Id',
            type: null,
            source: null,
            dataKey: 'institutionId',
            target: 'institutionId',
            submit: true,
        },
        {
            id: 'all',
            choice: 'binderIds',
            choiceLabel: 'Choose the binders you would like to include in this report',
            isChoiceRequired: true,
            isChoiceHidden: false,
            label: 'Include all binders',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'binderIds',
            choice: 'binderIds',
            choiceLabel: 'Choose a list of binders to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only these binders',
            type: 'multiselect',
            source: 'binders',
            dataKey: 'binders',
            target: 'binderIds',
            targetKey: 'key',
            submit: true,
        },
    ],
};
